import React, { useState } from "react";
import { Col, Image, Modal, Row } from "react-bootstrap";
import icTitle from "../../../assets/images/message-line.svg";
import icNext from "../../../assets/images/ic-arrow-next.svg";
import ENGModalBody from "../../../components/modal/ENGModalBody";
import ENGModalFooter from "../../../components/modal/ENGModalFooter";
import ENGModalHeader from "../../../components/modal/ENGModalHeader";
import { dev } from "../../../features/network/ApiCall";

const LeaderMessageModal = ({ type, item }: { type: number; item: any }) => {
  const [modalShow, setModalShow] = useState(false);

  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);
  const [messageArray, setMessgeArray] = useState([item]);
  return (
    <>
      <a
        onClick={handleShow}
        style={{
          backgroundColor: "#fff",
          color: "#e31837",
          // fontWeight: "bold",
          fontFamily: "Saira",
          fontWeight: 600,
          fontSize: "12px",
          textTransform: "uppercase",
        }}
      >
        <b>
          <span
            style={{ fontSize: "12px", cursor: "pointer", fontWeight: 600 }}
          >
            Continue Reading
          </span>{" "}
          <span>
            <Image
              src={icNext}
              style={{
                width: "24px",
                height: "24px",
              }}
            />
          </span>
        </b>
      </a>

      <Modal
        show={modalShow}
        onHide={handleClose}
        backdrop="static"
        size="lg"
        keyboard={false}
      >
        <ENGModalHeader icon={icTitle} title="Message from Mahindra Leaders" />
        <ENGModalBody
          contents={
            <>
              <div style={styles.divGrey}>
                <Image
                  src={`${dev}/admin/download?fileName=${item.image}`}
                  style={{
                    marginBottom: "-50px",
                    width: "128px",
                    height: "128px",
                    borderRadius: "50%",
                  }}
                />
              </div>
              <Row style={styles.divWhite}>
                <Col lg={12} style={styles.name}>
                  {item.name}
                </Col>
                <Col lg={12} style={styles.designation}>
                  {item.designation}
                </Col>
                <Col lg={12} style={styles.message}>
                  {item.message}
                </Col>
              </Row>
            </>
          }
        />
        <ENGModalFooter closeMethod={handleClose} />
      </Modal>
    </>
  );
};

const styles: any = {
  divGrey: {
    backgroundColor: "#faf9f9",
    paddingTop: "40px",
    paddingLeft: "40px",
  },
  divWhite: {
    backgroundColor: "#fffff",
    paddingTop: "40px",
    paddingLeft: "40px",
    paddingRight: "40px",
    paddingBottom: "30px",
  },
  bgGrey: {
    backgroundColor: "#faf9f9",
  },
  p0: {
    padding: "0px",
  },
  continue: {
    float: "right",
    textAlign: "right",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 2,
    letterSpacing: "normal",
  },
  button: {
    padding: "13px 40px",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: 400,
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#e31837",
    // lineHeight: 2,
    letterSpacing: "normal",
    border: "0px",
  },
  name: {
    fontFamily: "Saira",
    fontSize: "18px",
    fontWeight: "600",
    fontStrech: "normal",
    textAlign: "left",
    marginTop: "32px",
  },
  designation: {
    fontFamily: "Saira",
    fontSize: "18px",
    fontWeight: "normal",
    fontStrech: "normal",
    textAlign: "left",
    marginBottom: "32px",
  },
  message: {
    fontFamily: "Saira",
    fontSize: "18px",
    fontWeight: "normal",
    fontStrech: "normal",
    textAlign: "left",
  },
};

export default LeaderMessageModal;
